<template>
  
  <search-picker 
    ref="searchPicker"
    path="users"
    :query="query" 
    :attributes="attributes"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"
  import UserService from "@/services/user-service"

  export default {

    name: "UserPicker",

    data() {
      return {
        query: "",
      }
    },

    props: {
      attributes: { type: String, default: "id,name,lastName,email,group,groupName" },
      authToken: { type: String },
      fluid: { type: Boolean, default: true },
      onlySimavet: { type: Boolean, default: false },    
      uppercase: { type: Boolean, default: false },  
    },
    
    components: {
      SearchPicker,
    },  

    mounted() {

      if (this.onlySimavet)
        this.query = "onlySimavet=true"
    },  

    methods: {

      renderTitle(user) {

        let title = user.name.trim() + " " + user.lastName

        if (this.uppercase)
          title = title.toUpperCase()

        return title
      },

      renderDescription(user) {
        return `<div class="m-t-10"><i class="${ UserService.GROUPS[user.group].icon }"></i> ${user.groupName}</div>`
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(user) {
        this.$emit("onPick", user)
      },

      setSelected(user) {
        this.$refs.searchPicker.setSelected(user)
      },
    },
  }

</script>